var ctAbsenceRequestsModel;

(function ($) {
 	$.fn.capitechAbsenceRequests = function() {
		var $ctabsenceRequestsElm = $(this);
		var options = {}
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			options = { 
				extend: {
					"{root}": function(absenceRequests) {
						absenceRequestTemplate = function (absenceRequest) {
							if (absenceRequest.absenceRequestStatus() == 'Created') {
								return 'createdAbsenceRequestsTemplate';
							} else {
								return 'defaultAbsenceRequestsTemplate';
							}
						};
						deleteAbsenceRequest = function (absenceRequest) {
							apiDeleteAbsenceRequest(absenceRequest);
						};
					},
					"{root}.absenceRequests[i]": function(absenceRequest){
						absenceRequest.translatedStatus = ko.computed(function() {
							var currentStatus = absenceRequest.absenceRequestStatus();
							if (currentStatus == 'Accepted') {
								return getResource('absence.statusAccepted', 'Fravær registrert');
							} else if (currentStatus == 'Rejected') {
								return getResource('absence.statusRejected', 'Avslag');
							} else if (currentStatus == 'Created') {
								return getResource('absence.statusCreated', 'Ikke håndtert');
							} else {
								return getResource('absence.statusUnknown', 'Ukjent status');
							}
						}, absenceRequest);
					}
				}
			}
			getAbsenceRequests();
		}
		
		function getAbsenceRequests() {
			var currentDate = new Date();
			var currentYear = currentDate.getFullYear();
			var firstDateOfYear = currentYear + '-01-01';
			var success = function success(data, textStatus, jqXHR) {
				var modelData = {};
				
				// Hide loader
				loaderIndicator(false);
				
				if (data.success == true) {
					modelData.absenceRequests = data.content;
					ctAbsenceRequestsModel = ko.viewmodel.fromModel(modelData, options);
					$('*[data-ko-bind="ctAbsenceRequestsModel"]').each(function(index, obj) {
						ko.applyBindings(ctAbsenceRequestsModel, obj);
					});
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				// Hide loader
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			// Show loader
			loaderIndicator(true);
			_api.getAbsenceRequests_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), firstDateOfYear);
		}
		
		function apiDeleteAbsenceRequest(absenceRequest) {
			var success = function success(data, textStatus, jqXHR) {
				// Hide loader
				loaderIndicator(false);
				if (data.success == true) {
					ctAbsenceRequestsModel.absenceRequests.remove(absenceRequest);
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				// Hide loader
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			
			sweetAlert({
				title: getResource('app.confirmDeletionTitle'),
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#DD6B55",
				confirmButtonText: getResource('app.delete'),
				cancelButtonText: getResource('app.cancel')
			},function() {
				// Show loader
				loaderIndicator(true);
				// API delete
				_api.deleteAbsenceRequest_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME), absenceRequest.id());
			});
		}
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));